import { ErrorMessage as FormikErrorMessage } from 'formik';
import { FC } from 'react';
import { ErrorMessage } from './ErrorMessage';

interface Props {
    name: string;
    className?: string;
}

export const FormErrorMessage: FC<Props> = ({ name, className }) => {
    return (
        <FormikErrorMessage
            component={ErrorMessage}
            name={name}
            className={className}
        />
    );
};
